import { useEffect, useState } from 'react';

const Content = ({ children }) => {
    const [stylesLoaded, setStylesLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
        const stylesheetPromises = stylesheets.map((stylesheet) => {
            if (stylesheet.sheet) return Promise.resolve();

            return new Promise((resolve) => {
                stylesheet.addEventListener('load', resolve, { once: true });
                stylesheet.addEventListener('error', resolve, { once: true });
            });
        });

        Promise.all([...stylesheetPromises, document.fonts?.ready ?? Promise.resolve()]).then(
            () => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (!cancelled) setStylesLoaded(true);
                    });
                });
            },
        );

        return () => {
            cancelled = true;
        };
    }, []);

    if (!stylesLoaded) return null;

    return (
        <main className={`anikino__content`}>
            <div className={`anikino__content-box`}>{children}</div>
        </main>
    );
};

export default Content;
